import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const animationData = {
    fadeInList: [],
    delayTime: 0.15
}

const filterElements = (elements = []) => {
    const result = {
        animElems: [],
        fixElems: []
    }

    elements.forEach(element => {
        const bouding = element.getBoundingClientRect()
        
        if (bouding.top > 0 && (bouding.top - window.innerHeight) < 0) {
            result.animElems.push(element)
        } else {
            result.fixElems.push(element)
        }
    });

    return result
}

const initFadeIn = (selector) => {
    ScrollTrigger.batch(selector, {
        fastScrollEnd: true,
        onEnter: (elements) => {
            gsap.from(elements, {
                autoAlpha: 0,
                stagger: animationData.delayTime,
                ease: "power1.out",
                duration: 1.2,
                onStart() {
                    elements.forEach((elem) => {
                        elem.classList.add("dis-transition");
                    });
                },
                onComplete() {
                    elements.forEach((elem) => {
                        elem.classList.remove("dis-transition");
                    });
                },
            });
        },
        // once: true,
        // start: "center bottom",
    });
}

const initFadeInUp = (selector) => {
    ScrollTrigger.batch(selector, {
        onEnter: (elements) => {
            const {animElems, fixElems} = filterElements(elements)

            if (animElems.length > 0) {
                gsap.from(animElems, {
                    autoAlpha: 0,
                    y: 60,
                    stagger: animationData.delayTime,
                    ease: "power3.out",
                    duration: 1.2,
                    onStart() {
                        animElems.forEach((elem) => {
                            elem.classList.add("dis-transition");
                        });
                    },
                    onComplete() {
                        animElems.forEach((elem) => {
                            elem.classList.remove("dis-transition");
                        });
                    },
                });
            }

            if (fixElems.length > 0) {
                gsap.set(fixElems, {
                    autoAlpha: 1
                })
            }
        },
        once: true,
    });
}

const initFadeLeft = (selector) => {
    ScrollTrigger.batch(selector, {
        fastScrollEnd: true,
        onEnter: (elements) => {
            const { animElems, fixElems } = filterElements(elements)
            
            if (animElems.length > 0) {
                gsap.from(animElems, {
                    autoAlpha: 0,
                    x: 120,
                    stagger: animationData.delayTime,
                    ease: "power2.out",
                    duration: 1.2,
                    onStart() {
                        animElems.forEach((elem) => {
                            elem.classList.add("dis-transition");
                        });
                    },
                    onComplete() {
                        animElems.forEach((elem) => {
                            elem.classList.remove("dis-transition");
                        });
                    },
                });
            }

            if (fixElems.length > 0) {
                gsap.set(fixElems, {
                    autoAlpha: 1
                })
            }
        },
        once: true,
        // start: "center bottom",
    });
}

const initFadeInDown = (element) => {
    const delay = parseInt(element.dataset.delay) - 1
    gsap.fromTo(element, {
        opacity: 0,
        y: -80
    }, {
        scrollTrigger: element, 
        duration: 1,
        ease: 'power3.out',
        opacity: 1,
        delay: delay * animationData.delayTime,
        y: 0,
        onStart() {
            element.classList.add("dis-transition")
        },
        onComplete() {
            element.classList.remove("dis-transition")
        }
    });
}

const initParallaxEffect = () => {
    if (window.innerWidth < 1200)
        return

    gsap.utils.toArray("[data-depth]").forEach(layer => {
        // console.log(layer.dataset.parent)
        // const parent = layer.
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: layer.dataset.parent,
                start: "top top",
                end: "bottom top",
                scrub: true
            }
        });
        
        const depth = layer.dataset.depth;
        const movement = -(layer.offsetHeight * depth)
        tl.to(layer, {y: movement, ease: "none"}, 0)
    });
}

const initAnimation = () => {
    document.addEventListener("DOMContentLoaded", function () {
        setTimeout(() => {
            initFadeInUp('[data-anim="fadeInUp"]')
            initFadeIn('[data-anim="fadeIn"]')
            initFadeLeft('[data-anim="fadeLeft"]')
            // initParallaxEffect()
            // const elements = document.querySelectorAll("[data-anim]")

            // elements.forEach(elem => {
            //     switch (elem.dataset.anim) {
            //         case 'fadeInUp':
            //             initFadeInUp(elem)
            //             break
            //         case 'fadeInDown':
            //             initFadeInDown(elem)
            //             break
            //         case 'fadeIn':
            //             initFadeIn(elem)
            //             break
            //     }
            // })
        }, 500);
    })

}

export { initAnimation }